/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '../theme/theme';
import type { SpaceKey } from '../theme/theme';

export interface StackProps {
  children: ReactNode;
  /** 세로 간격. 애매하면 md. */
  gap?: SpaceKey;
}

/** 세로 나열 프리미티브. 화면 섹션, 패널 내부 블록 쌓기에 활용. */
export function Stack({ children, gap = 'md' }: StackProps) {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: ${theme.space[gap]}px;
      `}
    >
      {children}
    </div>
  );
}
